import { defineComponent as _defineComponent } from 'vue'
import {Proposal, ProposalType} from "@/models/store/proposal";
import ProposalChanges from "@/components/governance/ProposalParameterChange.vue";
import ProposalPlan from "@/components/governance/ProposalSoftwareUpgrade.vue";
import ProposalCommunityPoolSpend from "@/components/governance/ProposalCommunityPoolSpend.vue";
import ProposalNotLegacyContent from "@/components/governance/ProposalNotLegacyContent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProposalAdditionalContent',
  props: {
    proposal: { type: Object, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();


const props = __props;



const checkIfDisplay = () => {
  let type = props.proposal?.content?.type;
  if (type == ProposalType.COMMUNITY_POOL_SPEND || type == ProposalType.SOFTWARE_UPGRADE || type == ProposalType.PARAMETER_CHANGE
    || props.proposal?.type != ProposalType.LEGACY_CONTENT)
    return true;
  return false;
};


const __returned__ = { props, checkIfDisplay, get ProposalType() { return ProposalType }, ProposalChanges, ProposalPlan, ProposalCommunityPoolSpend, ProposalNotLegacyContent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})